// src/reducers/artistReducer.js
import {
  FETCH_ARTIST_PROFILE_REQUEST,
  FETCH_ARTIST_PROFILE_SUCCESS,
  FETCH_ARTIST_PROFILE_FAILURE,
  UPDATE_ARTIST_PROFILE_REQUEST,
  UPDATE_ARTIST_PROFILE_SUCCESS,
  UPDATE_ARTIST_PROFILE_FAILURE,
} from "../actions/types";

const initialState = {
  profile: null,
  loading: false,
  error: null,
};

const artistReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ARTIST_PROFILE_REQUEST:
    case UPDATE_ARTIST_PROFILE_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_ARTIST_PROFILE_SUCCESS:
    case UPDATE_ARTIST_PROFILE_SUCCESS:
      return { ...state, loading: false, profile: action.payload };

    case FETCH_ARTIST_PROFILE_FAILURE:
    case UPDATE_ARTIST_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default artistReducer;
